import React, { useState, useEffect, useContext, useRef } from 'react';
import { Dropdown, Tag } from 'primereact';
import { useNavigate, useParams } from 'react-router-dom';
import { InputTextarea } from 'primereact/inputtextarea';
import { MultiSelect } from 'primereact/multiselect';
import { RadioButton } from 'primereact/radiobutton';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { Editor } from 'primereact/editor';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';


import { getPosiciones } from '../../../API/RRHH/Posiciones/PosicionesRequests';
import { getSecciones } from '../../../API/RRHH/Secciones/SeccionesRequests';
import { getPersonal } from '../../../API/RRHH/Personal/PersonalRequests';
import { getAgentesFirma } from '../../../API/Global/Agentes/AgentesRequests';
import { postMemo, getMemo, getArchivoMemo, deleteFileMemo } from '../../../API/Gerencia/Comunicados/ComunicadosRequests';



import Loader from '../../../Base/Components/Loader/Loader';
import { toastShow } from '../../../Base/Services/ToastService';
import Card from '../../../Base/Components/Card/Card';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';
import { setTitlePage } from '../../../Base/Services/Config/ConfigService';
import { getDateProduccionSQL } from '../../../Base/Services/FechasService';
import { getDateTimeStringSQL } from '../../../Base/Services/Moment/Luxon';


const estados = [
    {
        IdEstado: 3587,
        StatusName: 'Creado'
    },
    {
        IdEstado: 3588,
        StatusName: 'Distribuido'
    },
    {
        IdEstado: 3589,
        StatusName: 'Cancelado'
    },
    {
        IdEstado: 3591,
        StatusName: 'En Firma'
    },
    {
        IdEstado: 3596,
        StatusName: 'Aprobado'
    },
]

function ComunicadosScreen() {


    const toast = useRef(null);
    const navigate = useNavigate();


    const { memo } = useParams();

    const [Memo, setMemo] = useState({});



    const resetData = () => {
        setMemo({})
    };

    const changeEstado = (IdEstado) => {

    }

    const changeFechaMemo = (FechaMemo) => {

    }

    const changeIdMemo = (IdMemo) => {

    }

    const { userAuth } = useContext(AuthContext);

    const [IdMemo, setIdMemo] = useState(((new Date()).getTime() * -1) / 100000000);
    const [tipoInformativo, setTipoInformativo] = useState(0);
    const [TipoDestinatario, setTipoDestinatario] = useState(0);
    const [TipoEnvia, setTipoEnvia] = useState(1);
    const [enviaPersonal, setEnviaPersonal] = useState([]);
    const [enviaSeccion, setEnviaSeccion] = useState([]);
    const [destinatarioPersonal, setDestinatarioPersonal] = useState([])
    const [destinatarioSeccion, setDestinatarioSeccion] = useState([]);
    const [destinatarioOtro, setDestinatarioOtro] = useState('')
    const [personal, setPersonal] = useState([])
    const [date, setDate] = useState(new Date());
    const [asunto, setAsunto] = useState('');
    const [agentes, setAgentes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(false);
    const [posiciones, setPosiciones] = useState([])
    const [destinatarioPosicion, setDestinatarioPosicion] = useState([])
    const [estado, setEstado] = useState(estados[0]);
    const [saludoSelected, setSaludoSelected] = useState();
    const [conclusionSelected, setConclusionSelected] = useState();
    const [disableEstado, setDisableEstado] = useState(true);

    const [error, setError] = useState({})

    const [secciones, setSecciones] = useState([]);

    const [anexos, setAnexos] = useState([])

    const [Introduccion, setIntroduccion] = useState('')
    const [Contenido, setContenido] = useState('');
    const [Conclusion, setConclusion] = useState('');


    const introducciones = [
        {
            IdIntro: 0,
            Intro: 'Otro...'
        },
        {
            IdIntro: 1,
            Intro: 'Saludos cordiales.'
        },
        {
            IdIntro: 2,
            Intro: 'Estimados colaboradores.'
        },
        {
            IdIntro: 3,
            Intro: 'Equipo.'
        },
        {
            IdIntro: 4,
            Intro: 'Buen día a todos..'
        },
    ]

    const conclusiones = [
        {
            IdConclusion: 0,
            Conclusion: 'Otro...'
        },
        {
            IdConclusion: 1,
            Conclusion: 'Se anexan al comunicado los documentos relacionados.'
        },
        {
            IdConclusion: 2,
            Conclusion: 'Agradeciendo de antemano su valiosa colaboración.'
        },
        {
            IdConclusion: 3,
            Conclusion: 'Esperando prontos resultados'
        },
        {
            IdConclusion: 3,
            Conclusion: 'Cuento con su acostumbrado apoyo.'
        },
        {
            IdConclusion: 3,
            Conclusion: 'Muy atentamente me despido.'
        },
    ]



    const getInfo = async (Memo = null) => {
        setLoading(true);
        resetData();

        const secc = await getSecciones();
        const agent = await getAgentesFirma();
        const pers = await getPersonal();
        const posi = await getPosiciones();
        setPosiciones(posi)
        setPersonal(pers);
        setAgentes(agent);
        // HAY SECCIONES CON NOMBRES REPETIDOS PERO CON DIFERENTE
        const t = []
        secc.forEach(element => {
            const filter = t.filter(e => e.Seccion === element.Seccion)
            if (filter.length === 0) {
                t.push(element)
            }
        });
        setSecciones(t);
        // SI memo EXISTE ES EDITAR 
        let memoT = Memo ? Memo : memo
        if (memoT) {
            const t = await getMemo(memoT);
            if (t.length > 0) {
                const m = t[0];
                setIdMemo(m.idMemo);
                changeIdMemo({ IdMemo: m.idMemo });
                // setTipo()
                // setTipoInformativo()

                getAnexos(m.idMemo)

                setTipoEnvia(m.TipoEnvia);
                if (m.TipoEnvia === 0) {
                    setEnviaPersonal(m.Envia.split(',').map((e) => agent.filter(p => p.AgentCode === e)[0]));
                }
                if (m.TipoEnvia === 1) {
                    const d = m.Envia.split(',').map((e) => secc.filter(s => s.IdSeccion === parseInt(e))[0]);
                    setEnviaSeccion(d)
                }


                setTipoDestinatario(m.TipoDestinatario);
                if (m.TipoDestinatario === 0) {
                    setDestinatarioPersonal(m.Destinatario.split(',').map((e) => pers.filter(p => p.idpersonal === e)[0]));
                }
                if (m.TipoDestinatario === 1) {
                    setDestinatarioSeccion(m.Destinatario.split(',').map((e) => secc.filter( s => s.CodigoSeccion === e)[0]));
                }
                if (m.TipoDestinatario === 2) {
                    setDestinatarioOtro(m.Destinatario)
                }

                // 3 -> todo el personal

                if (m.TipoDestinatario === 4) {
                    setDestinatarioPosicion(m.Destinatario.split(',').map((e) => posi.filter(p => p.CodigoPosicion === e)[0]));
                }

                setEstado({
                    IdEstado: m.IdEstado,
                    StatusName: m.StatusName
                })
                if (userAuth.IdRol !== 1) {
                    if (m.IdEstado !== 3587) {
                        setDisable(true)
                    }
                } else {
                    setDisableEstado(false);
                }

                changeEstado(m.IdEstado)

                setAsunto(m.Asunto);
                setDate(new Date(m.FechaTable));
                // setEstado(estados.filter(e => e.IdEstado === m?.IdEstado))
                // setIdEstado(m.IdEstado);


                
                setIntroduccion(m.Introduccion);
                const a = introducciones.findIndex(e => e.Intro === m.Introduccion)

                if (introducciones[a]) {
                    setSaludoSelected(introducciones[a]);
                    setIntroduccion(m.Introduccion);
                } else {
                    setSaludoSelected({ IdIntro: 0 });
                }
    

                setContenido(m.Contenido);


                setConclusion(m.Conclusion);
                const c = conclusiones.findIndex(e => e.Conclusion === m.Conclusion)

                if (conclusiones[c]) {
                    setConclusionSelected(conclusiones[c])
                } else {
                    setConclusionSelected({IdConclusion: 0})
                }
                setTipoInformativo(m.TipoInformativo);
                setLoading(false);



            } else {
                toastShow(toast, 'error', 'Memorándum no encontrado.')
            }
        }


        setLoading(false);
    }


    const getAnexos = async (IdMemo) => {
        const a = await getArchivoMemo(IdMemo);
        setAnexos(a)
    }


    const verificarCampos = () => {
        const e = {
            error: false
        }
        if (TipoEnvia === 1) {
            if (enviaSeccion.length === 0) {
                e.error = true;
                e.enviaSeccion = true;
            }
        }

        if (TipoEnvia === 0) {
            if (enviaPersonal.length === 0) {
                e.error = true;
                e.enviaPersonal = true;
            }
        }

        if (TipoDestinatario === 0) {
            if (destinatarioPersonal.length === 0) {
                e.error = true;
                e.destinatarioPersonal = error
            }
        }

        if (TipoDestinatario === 1) {
            if (destinatarioSeccion.length === 0) {
                e.error = true;
                e.destinatarioSeccion = error
            }
        }

        if (TipoDestinatario === 2) {
            if (destinatarioOtro.length === 0) {
                e.error = true;
                e.destinatarioOtro = error
            }
        }

        if (date === null || date === undefined) {
            e.error = true;
            e.date = true;
        }

        if (asunto === '') {
            e.error = true;
            e.asunto = true;
        }

        if (tipoInformativo === 0) {
            if (Contenido?.length === 0) {
                e.error = true;
                e.value = true;
            }
        }



        setError(e)
        if (e.error) {
            toastShow(toast, 'error', 'Error', 'Debe completar todos los campos.')
        }
        return (e)
    }

    const guardarMemo = async () => {
        setLoading(true);
        const error = verificarCampos()
        if (error.error) {
            console.error(error)
            setLoading(false)
            return;
        }

        let envia = [];
        let destinatario = [];

        let CodSeccion = '';

        if (TipoEnvia === 1) {
            envia = enviaSeccion.map(e => e.IdSeccion);
            if (enviaSeccion.length > 1) {
                CodSeccion = 'G';
            } else {
                const a = secciones.filter(e => enviaSeccion.includes(e.IdSeccion));
                if (a.length > 0) {
                    CodSeccion = a[0].CoSeccion
                } else {
                    CodSeccion = 'G'
                }
            }
        }


        if (TipoEnvia === 0) {
            envia = enviaPersonal.map(e => e.AgentCode);
            CodSeccion = 'P';
        }

        if (TipoDestinatario === 0) {
            destinatario = destinatarioPersonal.map(e => e.idpersonal);
        }

        if (TipoDestinatario === 1) {
            destinatario = destinatarioSeccion.map(e => e.CodigoSeccion);
        }

        if (TipoDestinatario === 2) {
            destinatario = destinatarioOtro;
        }

        // 3 -> TODOS EL PERSONAL

        if (TipoDestinatario === 4) {
            destinatario = destinatarioPosicion.map(e => e.CodigoPosicion);
        }

        const memoEnvia = {
            IdMemo: IdMemo,
            Memo: memo ? memo : '',
            IdEstado: estado?.IdEstado, //CREADO
            TipoEnvia: TipoEnvia,
            Envia: envia.toString(),
            TipoDestinatario: TipoDestinatario,
            Destinatario: destinatario.toString(),
            Fecha: getDateTimeStringSQL(date),
            Asunto: asunto,
            Introduccion: Introduccion,
            Contenido: Contenido,
            Conclusion: Conclusion,
            IdUserCreate: userAuth.idUser,
            FechaCreado: new Date(),
            TipoInformativo: tipoInformativo,
            Alimentacion: Memo.Alimentacion,
            Transporte: Memo.Transporte,
            CodSeccion: CodSeccion
        }

        // TRASNPORTE
        if (tipoInformativo === 1) {

        }

        // ALIMENTACION
        if (tipoInformativo === 2) {

        }

        const a = await postMemo(memoEnvia)
        if (a.length > 0) {
            toastShow(toast, 'success', 'Guardado', 'Memorándum guardado con exito.')
            getInfo(a[0].Memo)
            setTimeout(() => {
                navigate(`${process.env.REACT_APP_ENV}/Admin/Memorandum/Edit/` + a[0].Memo)
                setLoading(false)
            }, 1000);
        } else {
            toastShow(toast, 'error', 'Error', 'Error al guardar el memorándum.')
            setLoading(false)
        }
    }

    const changeTipoMemo = (tipo) => {
        setTipoInformativo(tipo)
        if (tipo !== 0) {
            setTipoDestinatario(3)
        }
    }


    // const uploadHandler = async (e) => {
    //     for (let i = 0; i < e.files.length; i++) {
    //         var formData = new FormData();
    //         formData.append("image", e.files[i]);
    //         formData.append("IdMemo", IdMemo);
    //         formData.append("idUserUpload", 3);
    //         formData.append("Pie", labelImg ? labelImg : '');
    //         formData.append('Titulo', Titulo ? Titulo : '');
    //         formData.append('Orden', orden ? orden : 0);
    //         formData.append('TypeDisplay', tipoAnexo ? tipoAnexo : 0);

    //         axios.post(`${instancias.API_URL}/Memo/upload?${Date.now()}`, formData, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data',
    //                 'x-access-token': localStorage.getItem('ppfToken'),
    //             }
    //         })

    //         toastShow(toast, 'success', 'Archivo Agregado')
    //         setLabelImg('');
    //         setTitulo('');
    //         setOrden();
    //         fileUpload.current.clear();
    //     }

    //     setTimeout(() => {
    //         getAnexos(IdMemo)
    //     }, 1000);

    // }

    const deleteFile = async (anexo) => {
        const a = await deleteFileMemo(anexo.IdImg);
        console.log(a);
        getAnexos(IdMemo);
    }


    const table = {
        Data: anexos,
        Columns: [
            {
                header: 'Titulo',
                field: 'Titulo'
            },
            {
                header: 'Pie',
                field: 'Pie'
            },
            {
                header: 'Nombre',
                field: 'Nombre'
            },
            {
                header: 'Orden',
                field: 'Orden'
            },
            {
                header: 'TypeDisplay',
                field: 'TypeDisplay',
                Format: 'Template',
                body: (rowData) => {
                    switch (rowData.TypeDisplay) {
                        case 0:
                            return <span>Página completa</span>
                            break;
                        case 1:
                            return <span>Media página</span>
                        default:
                            return <span></span>
                            break;
                    }
                }
            },

            {
                // Botones
                field: 'Botones',
                header: '',
                body: (rowData) => <div>
                    <span className='p-button-text pi pi-trash mx-2' tooltip='Borrar Anexo' onClick={e => deleteFile(rowData)} />
                    <span className='p-button-text pi pi-eye mx-2' tooltip='Borrar Anexo' onClick={e => window.open(`https://were.ppf.com.hn/assets/memo/anexos/${rowData.Nombre}`, rowData.Nombre, 'height=1200,width=1000')} />
                </div>,
                Format: 'Template'

            },
        ]
    }

    const estadoTemplate = (e) => {
        switch (e.IdEstado) {
            case 3587:
                return <Tag style={{ width: 100 }} severity="warning" value={e.StatusName} />
            case 3588:
                return <Tag style={{ width: 100 }} severity="primary" value={e.StatusName} />
            case 3589:
                return <Tag style={{ width: 100 }} severity="danger" value={e.StatusName} />
            case 3591:
                return <Tag style={{ width: 100 }} severity="info" value={e.StatusName} />
            case 3596:
                return <Tag style={{ width: 100 }} severity="success" value={e.StatusName} />

            default:
                return <span></span>
        }
    }

    const confirmarNuevo = () => {
        confirmDialog({
            message: "¿Está seguro de crear un nuevo comunicado?. Perderá los cambios registrados en este formulario",
            header: "Nuevo Comunicado",
            icon: "pi pi-exclamation-triangle",
            acceptLabel: "Sí",
            accept: () => {
                {
                    setIdMemo(((new Date()).getTime() * -1) / 100000000)
                    setEnviaPersonal('')
                    setEnviaSeccion('')
                    setAsunto('')
                    setContenido('')
                    setConclusion('')
                    setIntroduccion('')
                    setConclusionSelected('')
                    setSaludoSelected('')
                    setDestinatarioPersonal('')
                    setDate(new Date())
                }
                setDisableEstado(true);
                navigate(`${process.env.REACT_APP_ENV}/Admin/Memorandum/New`);

            },
            rejectLabel: "No",
            reject: () => {}, 
            style: { backgroundColor: "white" },
        });
    }

    useEffect(() => {
        setTitlePage('Comunicados')
        getInfo();
        changeIdMemo({ IdMemo: IdMemo, Memo: memo })
    }, [])

    useEffect(() => {
        changeIdMemo({ IdMemo: IdMemo, Memo: memo })
    }, [IdMemo])

    useEffect(() => {
        // ALIMENTACION
        if (tipoInformativo === 2) {
            setAsunto('Menú de la semana');
            setTipoEnvia(1);
            setEnviaSeccion(secciones.filter(e => e.IdSeccion === 1002));
            setIntroduccion('');
            setConclusion('');

        }
        if (tipoInformativo === 1) {
            setAsunto('PROGRAMACIÓN DE TRANSPORTE');
            setTipoEnvia(1)
            setEnviaSeccion(secciones.filter(e => e.IdSeccion === 28));
            setIntroduccion('');
            setConclusion('');
        }
    }, [tipoInformativo])


    useEffect(() => {
        changeFechaMemo({ FechaMemo: date });
    }, [date])


    useEffect(() => {
        if (saludoSelected !== 0) {
            setIntroduccion(introducciones.filter(e => e.IdIntro === saludoSelected?.IdIntro)[0]?.Intro)
        }
    }, [saludoSelected])


    useEffect(() => {
        if(conclusionSelected){
            if (conclusionSelected.IdConclusion !== 0) {
                setConclusion(conclusionSelected.Conclusion)
            }
        }
    }, [conclusionSelected])



    useEffect(() => {
        if (saludoSelected?.IdIntro === 0) {
            setIntroduccion(saludoSelected.Intro);
        } 
    }, [saludoSelected]);


    return (
        <div className='px-2 memorandumCrud'>
            <Toast ref={toast} />
            <Loader loading={loading} querySelector={'.memorandumCrud'} />
            <ConfirmDialog />
            <div style={{
                position: 'fixed',
                zIndex: 100,
                background: 'var(--surface-a)',
                // background: '#f6f6f7',
                width: '90%',
                padding: 20,
                margin: 'auto',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}>
                <div style={{ flex: 1 }}>
                    <Button
                        tooltip='Lista de Comunicados'
                        tooltipOptions={{ position: 'top' }}
                        icon='pi pi-arrow-left'
                        onClick={() => {

                            confirmDialog({
                                message: "¿Está seguro de regresar a la lista de comunicados?. Perderá los cambios registrados en este formulario",
                                header: "Regresar",
                                icon: "pi pi-exclamation-triangle",
                                acceptLabel: "Sí",
                                accept: () => {
                                    navigate(`${process.env.REACT_APP_ENV}/Admin/Memorandum`);
                                },
                                rejectLabel: "No",
                                reject: () => {}, 
                                style: { backgroundColor: "white" },
                            });
                        }}
                    />
                    
                    <Button
                        className='mx-1'
                        placeholder='Vista previa'
                        icon='pi pi-book'
                        onClick={e => {confirmarNuevo()}}
                        tooltip={'Nuevo Comunicado'}
                        tooltipOptions={{ position: 'top' }}
                    />
                </div>
                
                <div className='d-flex' style={{ flex: 2, textAlign: 'center' }}>
                    <h1 style={{ margin: 0 }}>Comunicado {memo}</h1>
                    <div className='mx-4 mt-2'>
                        {estadoTemplate(estado)}
                    </div>
                </div>

                <div className="botones" style={{ flex: 1 }}>
                    
                    <Button
                        className='mx-1'
                        placeholder='Guardar'
                        tooltipOptions={{ position: 'top' }}
                        icon='pi pi-save'
                        onClick={guardarMemo}
                        disabled={disable}
                        tooltip={'Guardar'}
                        loading={loading}
                    />
                    <Button
                        className='mx-1'
                        placeholder='Vista previa'
                        icon='pi pi-eye'
                        disabled={!memo}
                        onClick={e => {
                            window.open(`${process.env.REACT_APP_ENV}/Memo/Preview/${memo}`, memo, 'height=1200,width=1000')
                        }}
                        tooltip={'Vista previa, debe de guardar para ver los cambios'}
                        tooltipOptions={{ position: 'top' }}
                    />

                    {tipoInformativo !== 0 && (
                        <Button
                            className='mx-1'
                            placeholder='Vista previa'
                            icon='pi pi-download'
                            onClick={e => {
                                window.open(`https://were.ppf.com.hn/assets/Formatos/Comunicados.xlsx`, "_blank")
                            }}
                            tooltip={'Descargar Formatos'}
                        />
                    )}

                </div>
            </div>


            <div >


                <Card
                    titulo={''}
                    contenido={(<div className='py-2' style={{ marginTop: 50 }}>

                        {/* TIPO */}
                        <div>
                            <Card titulo={<h4>Tipo comunicado</h4>}
                            style={{ background: 'var(--surface-f)' }}
                            styleTitle={{ background: 'var(--surface-f)' }}
                                contenido={<div className='pt-4 d-flex' style={{ height: 60 }}>
                                    <div className='col-6'>
                                        <div className=' d-flex align-items-center px-4'>
                                            <div className=" d-flex align-items-center" style={{ margin: 0 }} onClick={e => disable ? null : changeTipoMemo(0)}>
                                                <RadioButton name="Tipo" value={0} checked={tipoInformativo === 0} disabled={disable} />
                                                <label className='mx-2' htmlFor="city4">General</label>
                                            </div>
                                            <div className=" " style={{ margin: 0 }} onClick={e => disable ? null : changeTipoMemo(1)}>
                                                <RadioButton name="Tipo" value={1} checked={tipoInformativo === 1} disabled={disable} />
                                                <label className='mx-2' htmlFor="city4">Transporte</label>
                                            </div>
                                            <div className="" style={{ margin: 0 }} onClick={e => disable ? null : changeTipoMemo(2)}>
                                                <RadioButton name="Tipo" value={1} checked={tipoInformativo === 2} disabled={disable} />
                                                <label className='mx-2' htmlFor="city4">Alimentación</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            />
                        </div>

                        {/* ENCABEZADO */}
                        <Card
                            titulo={<h4>Encabezado</h4>}
                            style={{ background: 'var(--surface-f)' }}
                            styleTitle={{ background: 'var(--surface-f)' }}
                            contenido={(<div className='my-2' >
                                <div className='d-flex align-items-end'>

                                    {/* QUIEN ENVIA */}
                                    <div>
                                        <div className='p-2 d-flex align-items-center m-0'>
                                            <h6 >De:</h6>
                                            <div className='px-1 d-flex'>
                                                <div className='px-4 d-flex align-items-center'>

                                                    <div className="d-flex align-items-center" onClick={e => disable ? null : setTipoEnvia(1)}>
                                                        <RadioButton name="Tipo" value={1} checked={TipoEnvia === 1} disabled={disable || tipoInformativo !== 0} />
                                                        <label className='mx-2' htmlFor="city4">Seccion</label>
                                                    </div>
                                                    <div className="d-flex align-items-center" onClick={e => disable ? null : setTipoEnvia(0)}>
                                                        <RadioButton name="Tipo" value={0} checked={TipoEnvia === 0} disabled={disable || tipoInformativo !== 0} />
                                                        <label className='mx-2' htmlFor="city4">Personal</label>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div>
                                            {/* PERSONAL */}
                                            {TipoEnvia === 0 && <div className=' d-flex  align-items-center'>
                                                <MultiSelect
                                                    value={enviaPersonal}
                                                    options={agentes}
                                                    onChange={(e) => setEnviaPersonal(e.value)}
                                                    optionLabel='AgentName'
                                                    filter
                                                    filterBy='AgentName'
                                                    style={{ width: 500, height: 40 }}
                                                    display="chip"
                                                    className={classNames({ 'p-invalid': error?.enviaPersonal })}
                                                    disabled={disable || tipoInformativo !== 0}
                                                />

                                            </div>}

                                            {/* SECCIONES */}
                                            {
                                                TipoEnvia === 1 && <div className='d-flex  align-items-center'>
                                                    <div className="p-float-label ">
                                                        <MultiSelect
                                                            value={enviaSeccion}
                                                            options={secciones}
                                                            onChange={(e) => setEnviaSeccion(e.value)}
                                                            optionLabel="Seccion"
                                                            display="chip"
                                                            style={{ width: 500, height: 40 }}
                                                            filter
                                                            filterBy="Seccion"
                                                            multiple={false}
                                                            className={classNames({ 'p-invalid': error?.enviaSeccion })}
                                                            disabled={disable || tipoInformativo !== 0}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>



                                    {/* PARA */}
                                    <div className='d-flex justify-content-end flex-column'>
                                        <div >
                                            {tipoInformativo === 0 && <div className='p-2 d-flex align-items-center '>
                                                <h6 className='px-4'>Enviar a:</h6>
                                                <div className='px-4 d-flex'>


                                                    <div className="" onClick={e => disable ? null : setTipoDestinatario(0)}>
                                                        <RadioButton name="Tipo" value={0} checked={TipoDestinatario === 0} disabled={disable} />
                                                        <label className='mx-2' htmlFor="city4">Personal</label>
                                                    </div>

                                                    <div className="" onClick={e => disable ? null : setTipoDestinatario(1)}>
                                                        <RadioButton name="Tipo" value={1} checked={TipoDestinatario === 1} disabled={disable} />
                                                        <label className='mx-2' htmlFor="city4">Seccion</label>
                                                    </div>

                                                    <div className="" onClick={e => disable ? null : setTipoDestinatario(4)}>
                                                        <RadioButton name="Tipo" value={1} checked={TipoDestinatario === 4} disabled={disable} />
                                                        <label className='mx-2' htmlFor="city4">Posición</label>
                                                    </div>

                                                    <div className="" onClick={e => disable ? null : setTipoDestinatario(2)}>
                                                        <RadioButton name="Tipo" value={2} checked={TipoDestinatario === 2} disabled={disable} />
                                                        <label className='mx-2' htmlFor="city4">Otro</label>
                                                    </div>

                                                    <div className="" onClick={e => disable ? null : setTipoDestinatario(3)}>
                                                        <RadioButton name="Tipo" value={3} checked={TipoDestinatario === 3} disabled={disable} />
                                                        <label className='mx-2' htmlFor="city4">Todos</label>
                                                    </div>

                                                </div>


                                            </div>}
                                            {/* PERSONAL */}
                                            {
                                                TipoDestinatario === 0 &&
                                                <div className=' px-4 d-flex  align-items-center'>
                                                    <div className="p-float-label ">
                                                        <MultiSelect
                                                            value={destinatarioPersonal}
                                                            options={personal}
                                                            onChange={e => { setDestinatarioPersonal(e.value) }}
                                                            optionLabel={'NombreEmpleado'}
                                                            display='chip'
                                                            filter
                                                            filterBy='NombreEmpleado'
                                                            style={{ width: 500, height: 40 }}
                                                            className={classNames({ 'p-invalid': error?.destinatarioPersonal })}
                                                            disabled={disable}
                                                        />
                                                    </div>

                                                </div>
                                            }
                                            {/* SECCIONES */}
                                            {
                                                TipoDestinatario === 1 && <div className='px-4 d-flex  align-items-center'>
                                                    <div className="p-float-label ">
                                                        <MultiSelect
                                                            value={destinatarioSeccion}
                                                            options={secciones}
                                                            onChange={(e) => setDestinatarioSeccion(e.value)}
                                                            optionLabel="Seccion"
                                                            display="chip"
                                                            style={{ width: 500, height: 40 }}
                                                            filter
                                                            filterBy="Seccion"
                                                            className={classNames({ 'p-invalid': error?.destinatarioSeccion })}
                                                            disabled={disable}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {/* POSICIONES */}
                                            {
                                                TipoDestinatario === 4 && <div className='px-4 d-flex  align-items-center'>
                                                    <div className="p-float-label ">
                                                        <MultiSelect
                                                            value={destinatarioPosicion}
                                                            options={posiciones}
                                                            onChange={(e) => setDestinatarioPosicion(e.value)}
                                                            optionLabel="Posicion"
                                                            display="chip"
                                                            style={{ width: 500, height: 40 }}
                                                            filter
                                                            filterBy="Posicion"
                                                            className={classNames({ 'p-invalid': error?.destinatarioSeccion })}
                                                            disabled={disable}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {/* OTRO */}
                                            {TipoDestinatario === 2 && <div className='px-4 d-flex  align-items-center'>
                                                <InputText
                                                    value={destinatarioOtro}
                                                    onChange={e => setDestinatarioOtro(e.target.value)}
                                                    style={{ width: 500, height: 40 }}
                                                    className={classNames({ 'p-invalid': error?.destinatarioOtro })}
                                                />
                                            </div>
                                            }
                                            {TipoDestinatario === 3 && <div className='px-4 d-flex  align-items-center'><div style={{ width: 500, height: 40 }}></div></div>}
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex m-2 align-items-end'>
                                    {/* FECHA */}
                                    <div>
                                        <h6>Fecha:</h6>
                                        <div className="py-2">
                                            <Calendar
                                                showButtonBar
                                                dateFormat="dd/mm/yy"
                                                showIcon
                                                value={date}
                                                onChange={e => setDate(e.value)}
                                                className={classNames({ 'p-invalid': error?.date })}
                                                disabled={disable}
                                            />
                                        </div>
                                    </div>
                                    {/* ASUNTO */}

                                    <div className='mt-2 px-4'>
                                        <h6>Asunto</h6>
                                        <div className="py-2">
                                            <InputText
                                                style={{ width: 650 }}
                                                value={asunto}
                                                onChange={e => setAsunto(e.target.value)}
                                                className={classNames({ 'p-invalid': error?.asunto })}
                                                disabled={disable || tipoInformativo !== 0}
                                            />
                                        </div>
                                    </div>

                                    {!disableEstado && <div style={{ position: 'relative', top: '-10px' }}>
                                        <Dropdown
                                            value={estado}
                                            options={estados}
                                            optionLabel='StatusName'
                                            onChange={e => setEstado(e.value)}
                                            disabled={disableEstado}
                                        />
                                    </div>}
                                </div>
                            </div>)}
                        />

                        {/* CONTENIDO */}
                        <Card
                            titulo={''}
                            style={{ background: 'var(--surface-f)' }}
                            styleTitle={{ background: 'var(--surface-f)' }}
                            contenido={(<div
                                className={classNames('p-4', { 'p-invalid': error?.value })} >
                                {tipoInformativo === 0 && <div>
                                    <h5>Introducción</h5>
                                    <Dropdown
                                        options={introducciones}
                                        optionLabel='Intro'
                                        value={saludoSelected}
                                        onChange={e => setSaludoSelected(e.value)}
                                        styles={{ width: 800 }}
                                        className='col-6 my-2'
                                        disabled={disable}
                                    />
                                    {saludoSelected?.IdIntro === 0 && <InputTextarea
                                        value={Introduccion}
                                        onChange={(e) => setIntroduccion(e.target.value)}
                                        rows={30}
                                        cols={200}
                                        autoResize
                                        style={{ width: '100%', maxHeight: '10vh' }}
                                        disabled={disable}
                                    />}
                                </div>}
                                <h5>Contenido</h5>
                                <Editor
                                    style={{ height: '500px' }}
                                    value={Contenido}
                                    onTextChange={(e) => setContenido(e.htmlValue)}
                                />
                                {tipoInformativo === 0 && <div>
                                    <h5 className='mt-2'>Conclusión</h5>
                                    <Dropdown
                                        options={conclusiones}
                                        optionLabel='Conclusion'
                                        value={conclusionSelected}
                                        onChange={e => setConclusionSelected(e.value)}
                                        styles={{ width: 800 }}
                                        className='col-6 my-2'
                                        disabled={disable}
                                    />
                                    {conclusionSelected?.IdConclusion === 0 && <InputTextarea
                                        value={Conclusion}
                                        onChange={(e) => setConclusion(e.target.value)}
                                        rows={30}
                                        cols={200}
                                        autoResize
                                        style={{ width: '100%', maxHeight: '10vh' }}
                                        disabled={disable}
                                    />}
                                </div>}
                                {/* <Editor value={value} onTextChange={(e) => setValue(e.htmlValue)} style={{ height: '50vh'}}  /> */}
                                {/* <SlateEditor initialValue={textEditor} value={value} setValue={setValue} /> */}
                            </div>)}
                        />

                    </div>)}
                />
            </div>
        </div>
    )
}


export default ComunicadosScreen